import context from './catalogue-intro-context.cjs';

export const resolveCatalogueIntro = context.resolveCatalogueIntro;